var template = require('../templates/FurnishingModal.ejs');
var ModalFormView = require('commons/views/ModalForm');

require('models/Furnishing');

module.exports = ModalFormView.extend({
    initialize: function(options) {
        ModalFormView.prototype.initialize.apply(this, [_.extend(options, {
            template: template
        })]);
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/FurnishingModal.js